"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractWebServerEventBase = void 0;
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const web_extraction_1 = require("@snapchat/web-extraction");
const types_1 = require("./types");
function extractWebServerEventBase(pageType, webClientId = "") {
    const { canonicalUrl, referrer, deviceScreenWidth, deviceScreenHeight } = (0, web_extraction_1.extractBrowser)();
    const { browserName = "", os = "", deviceManufacturer = "", deviceName = "", deviceType = "", } = (0, web_extraction_1.extractUA)();
    const sessionId = (0, web_sc_cookies_1.tryGetActiveSession)() || "";
    return {
        browserName,
        canonicalUrl,
        deviceManufacturer,
        deviceName,
        deviceScreenHeight,
        deviceScreenWidth,
        deviceType,
        locale: "",
        os,
        pageId: types_1.PageType[pageType],
        queryParameters: "",
        referrer,
        scReferrer: "",
        sessionId,
        shareId: "",
        source: "",
        webClientId,
    };
}
exports.extractWebServerEventBase = extractWebServerEventBase;
//# sourceMappingURL=extraction.js.map